var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 107,
    viewBox: "0 0 252 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.998 73.2664V106.754H0.144531V73.2664C30.4362 66.2358 40.2449 0.185547 40.2449 0.185547H212.042C212.042 0.185547 221.707 66.2358 251.998 73.2664Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.998 73.2666H0.144531V106.754H251.998V73.2666Z",
    fill: "#C3D0D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1231 0.185547C72.1231 0.185547 62.4586 66.2358 32.0226 73.2664V106.754H0V73.2664C30.4359 66.2358 40.1004 0.185547 40.1004 0.185547H72.1231Z",
    fill: "#E52C4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M252 73.2664V106.754H219.978V73.2664C189.686 66.2358 180.021 0.185547 180.021 0.185547H212.044C212.044 0.185547 221.709 66.2358 252 73.2664Z",
    fill: "#E52C4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.568 73.6364V106.939H73.565L72.8438 73.4514C92.0285 54.5799 93.4709 0.185547 93.4709 0.185547H113.233C114.098 39.4087 103.568 73.6364 103.568 73.6364Z",
    fill: "#E52C4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.695 73.2658L174.973 106.753H144.97V73.4508C144.97 73.4508 134.44 39.4081 135.45 0H155.212C155.068 0.185015 156.654 54.5793 175.695 73.2658Z",
    fill: "#E52C4F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1672 73.2666H0.144531V106.754H32.1672V73.2666Z",
    fill: "#B11722"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M251.997 73.2666V106.939H220.118V73.2666H251.997Z",
    fill: "#B11722"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.713 73.2666C103.713 73.4516 103.713 73.4516 103.713 73.4516V106.754H73.7095L72.9883 73.2666H103.713Z",
    fill: "#B11722"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M175.69 73.2666L174.969 106.754H144.966V73.4516C144.966 73.4516 144.966 73.4516 144.966 73.2666H175.69Z",
    fill: "#B11722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoof);
export default __webpack_public_path__ + "static/media/roof.72ab3e659970e0d099410efedbc31788.svg";
export { ForwardRef as ReactComponent };